import React, { useEffect, useState } from 'react'
import { RealTimeContextProvider } from './context'
import { useDispatch, useSelector } from 'react-redux'
import { setPusherChannelDataAction } from '../../redux/actions/app'
import { getEnv } from '../../helpers/functions'
import { useSubscribeAndBindChannel } from '../../helpers/hooks'
import { changeStockChannelAction } from '../../config/channel-actions'
import { USER_STATUSES } from '../../config/options'
import { getPusher } from '../../config/pusher'

const RealTimeProvider = ({ children }) => {
    const [pusher, setPusher] = useState(null)
    const user = useSelector(state => state.app.auth.user)

    return (
        <>
            {user.status !== USER_STATUSES.blocked && (
                <Init pusher={pusher} setPusher={setPusher} user={user} />
            )}
            <RealTimeContextProvider value={{ pusher: pusher }}>{children}</RealTimeContextProvider>
        </>
    )
}

const Init = ({ pusher, setPusher, user }) => {
    const dispatch = useDispatch()

    const pusherProviderHandler = payload => {
        if (getEnv('REACT_APP_ENV') === 'local') {
            console.log(payload)
        }
        dispatch(setPusherChannelDataAction(payload))
    }

    useEffect(() => {
        if (!user?.id) return

        setPusher(getPusher())
    }, [setPusher, user])

    useSubscribeAndBindChannel(
        'supplier-handler-channel',
        'supplier-handler',
        pusherProviderHandler,
        [],
        pusher
    )

    useSubscribeAndBindChannel(
        `private-supplier-handler-channel-${user.id}`,
        'supplier-handler',
        pusherProviderHandler,
        [],
        pusher
    )

    useSubscribeAndBindChannel(
        `stock_provider_${user.id_provider}`,
        changeStockChannelAction,
        data => {
            pusherProviderHandler({
                action: changeStockChannelAction,
                data,
            })
        },
        [],
        pusher
    )

    return null
}

export default RealTimeProvider
